<template>
  <el-dialog :title="isEdit?'编辑项目':'添加项目'"
             :visible.sync="visible"
             @open="init"
             @close="close"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="600px">
    <el-form :model="info" ref="record-form" label-width="80px" size="small">
      <el-row :gutter="20">
        <el-form-item label="项目名称" prop="name" :rules="[{ required: true, message: '请填写项目名称', trigger: 'blur' }]">
          <el-input v-model="info.name" placeholder="请填写项目名称" />
        </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <el-form-item prop="unit" label="目标企业" :rules="[{ required: true, message: '请填写目标企业', trigger: 'blur' }]">
          <el-input v-model="info.unit" placeholder="请填写目标企业" />
        </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <el-form-item label="开始时间" prop="startTime" :rules="[{ required: true, message: '请选择答题开始时间', trigger: 'blur' }]">
          <el-date-picker
            v-model="info.startTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="请选择答题开始时间">
          </el-date-picker>
        </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <el-form-item label="结束时间" prop="endTime" :rules="[{ required: true, message: '请选择答题结束时间', trigger: 'blur' }]">
          <el-date-picker
            v-model="info.endTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="请选择答题结束时间">
          </el-date-picker>
        </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <el-form-item label="客户公司" prop="customerId">
          <el-select clearable v-model="info.customerId" placeholder="请选择客户公司">
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-divider content-position="left" @click="() => { this.isHight = !this.isHight }">高级配置<i :class="this.isHight ? 'fa fa-angle-down' : 'fa fa-angle-up'" style="transition: 0.5s"></i>
      </el-divider>
      <div v-show="this.isHight">
        <el-row :gutter="20">
          <el-form-item label="项目密码" prop="password" :rules="[{ min:3,max:6, message: '密码长度限制3-6位', trigger: 'blur' }]">
            <el-input v-model="info.password" placeholder="若填写，测评人员需要输入密码才能测评" />
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-form-item label="报告免费" prop="free" :rules="[{ required: true, message: '请选择是否免费', trigger: 'blur' }]">
            <el-radio-group v-model="info.free" req placeholder="请选择">
              <el-radio :label="1">免费</el-radio>
              <el-radio :label="0">收费</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-form-item v-if="info.free==0" label="收费价格" prop="price" :rules="[{pattern: /^([1-9]\d{0,2}|1000)(\.\d{1})?$/,message: '范围在0-1000', trigger: 'blur'}]">
            <el-input type="number" v-model="info.price" placeholder="学员查看完整报告需要支付相关费用" />
          </el-form-item>
        </el-row>
      </div>
    </el-form>
    <div slot="footer">
      <el-button @click="close" size="small"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button type="primary" @click="save()" size="small"><i class="fa fa-save"></i> 确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getFencScheme } from "@api/evaluation/scheme";
import { fetchData } from "@api/evaluation/form";
import { fetchList as findCustomer } from "@/api/enterprise/customer";
import { get, save, update } from "@api/evaluation/project";
import { mapGetters } from "vuex";


export default {
  name: "",
  props: {
    visible: false,
    projectId: null
  },
  watch: {
    "info.customerId": {
      handler(newType, oldType) {
        this.customerList.forEach(o => {
          if (o.id == this.info.customerId) {
            this.info.customerName = o.name;
          }
        });
      }
    }
  },
  computed: {
    ...mapGetters(["user", "company"]),
    isEdit() {
      return this.projectId;
    }
  },
  data() {
    return {
      info: {
        schemeId: null,
        schemeType: "standard",
        scheme: {}
      },
      formList: [],
      fencScheme: {},
      customerList: [],
      modelList: [],
      isHight: false
    };
  },
  methods: {
    init() {
      this.info = {
        schemeId: null,
        free: 1,
        schemeType: "standard",
        scheme: {}
      };
      this.fetchData();
      this.getFencScheme();
      this.findCustomer();
    },
    findCustomer() {
      findCustomer(this.company.id, { pageSize: 1000 }).then(resp => {
        this.customerList = resp.data.result.records;
      });
    },
    fetchData() {
      if (this.isEdit) {
        get(this.projectId).then(resp => {
          this.info = resp.data.result;
          this.info.startTime = this.info.startTime * 1000;
          this.info.endTime = this.info.endTime * 1000;
        });
      }

      fetchData(this.user.id).then(resp => {
        this.formList = resp.data.result || {};
      });
    },
    getFencScheme() {
      getFencScheme().then(resp => {
        this.fencScheme = resp.data.result || {};
      });
    },
    close() {
      this.$emit("done", false);
    },
    save() {
      this.$refs["record-form"].validate(valid => {
        if (valid) {
          this.info.userId = this.user.id;
          this.info.startTime = this.info.startTime / 1000;
          this.info.endTime = this.info.endTime / 1000;
          this.info.type = 2;
          this.info.schemeId = this.fencScheme.id;
          this.info.userId = this.user.id;
          this.info.schemeName = this.fencScheme.name;
          if (this.isEdit) {
            update(this.info).then(resp => {
              this.$emit("done", true);
            });
          } else {
            save(this.info).then(resp => {
              this.$emit("done", true);
            });
          }
        }
      });
    }
  },
  submitCallback(resp) {
    if (resp.status === 200) {
      this.info = {};
      this.$message.success(resp.data.message);
      this.fetchData();
      this.addDrawer = false;
    }
  }
};
</script>

